import React, { useState, FC } from 'react';
import { TProductAttachmentSeriesWithFilterProps } from './types/productAttachmentSeriesWithFilter.types';
import useMediaQuery from '../../hooks/useMediaQuery';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import DesktopFilter from './components/desktopFilter';
import MobileFilter from './components/mobileFilter';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { ComponentConsumerProps, isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import SeriesListing from '../@shared/seriesListing';
import { FilterContext, TFilterContextData } from './fiilterContext';
import { ProductAttachmentSeriesWithFilterModel } from './models/productAttachmentSeriesWithFilter.model';
import { ALL_MODELS, ALL_SERIES } from '../../constants/seriesFilter.constants';
import NoMatch from '../@shared/filters/components/noMatch';

const ProductAttachmentSeriesWithFilter: FC<ComponentConsumerProps & TProductAttachmentSeriesWithFilterProps> = (props) => {
  const apiResponse = isEmptyResponse(props) && Number(props?.fields?.apiData?.cards?.length) > 0;
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`);
  const model = new ProductAttachmentSeriesWithFilterModel(props);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<TFilterContextData>({
    modelSelectedInd: ALL_MODELS,
    seriesSelectedInd: ALL_SERIES,
    searchedTerm: '',
    model,
  });

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  const updateFilters = (newFilters = {}) => {
    setSelectedFilters({ ...selectedFilters, ...newFilters });
    !shouldAnimate && setShouldAnimate(true);
  };

  const filteredCards = model.filterCards(selectedFilters);

  return (
    <>
      <FilterContext.Provider value={{ ...selectedFilters, updateFilters }}>
        {isWide ? <DesktopFilter /> : <MobileFilter />}
      </FilterContext.Provider>
      {filteredCards?.length == 0 && (
        <NoMatch titleDictionaryKey="cnhi-filter-noMatchesFoundTitle" descriptionDictionaryKey="cnhi-filter-noMatchesFoundDescription" />
      )}
      <SeriesListing
        {...{
          children: <></>,
          shouldAnimate,
          fields: {
            isComponentUnreleased: false,
            apiData: {
              items: filteredCards,
            },
            itemData: {
              contextItemUrl: props?.fields?.itemData?.contextItemUrl || '',
            },
          },
        }}
      />
    </>
  );
};

export default withSitecoreContext()(ProductAttachmentSeriesWithFilter);
